import App from 'app/app.js';
import 'app/service/EventService.js';

function DeserializeAction(EventService) {
  this.eventName = 'deserialize';

  this.dispatch = function (dataObj) {
    EventService.dispatch(this.eventName, dataObj);
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('DeserializeAction', ['EventService', DeserializeAction]);
